"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSendQueue = void 0;
class BaseSendQueue {
    /**
     * @param sendNow Function to call to send a message
     * @param canSend Function which should return whether send can be called
     * @note If parameters are not passed, initialize() should be called later.
     */
    constructor(sendNow, canSend) {
        this.sendNow = (bytes) => -1;
        this.canSend = () => false;
        if (sendNow && canSend) {
            this.initialize(sendNow, canSend);
        }
        else if (sendNow || canSend) {
            throw new Error('Both sendNow and canSend must be provided, or neither must.');
        }
    }
    /**
     * @param sendNow Function to call to send a message
     * @param canSend Function which should return whether send can be called
     */
    initialize(sendNow, canSend) {
        this.sendNow = sendNow;
        this.canSend = canSend;
    }
    send(bytes) {
        throw new Error('not implemented');
    }
    queueMessage(bytes) {
        throw new Error('not implemented');
    }
    processQueue() {
        throw new Error('not implemented');
    }
}
exports.BaseSendQueue = BaseSendQueue;
exports.default = BaseSendQueue;
